import React, { useState, useEffect } from 'react'
import { Tag, Button } from 'antd'
import { SignalFilled } from '@ant-design/icons'

export const JobShowPostpone = ({ item }) => {
  useEffect(() => {}, [])

  return (
    <React.Fragment>
      <span
        style={{
          minWidth: 100,
          textAlign: 'center',
          color: 'red',
        }}
      >
        {item.postpone_mark && item.postpone_mark == 1
          ? '[คิวงานนี้กำลังรอระบุวันนัดหมายใหม่]'
          : null}
        {item.postpone_mark && item.postpone_mark == 2
          ? '[รอแอดมินยืนยันกับลูกค้า]'
          : null}
      </span>
    </React.Fragment>
  )
}
